import classNames from 'classnames';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { generatePath, Link, useLocation } from 'react-router';

import { getSelectedGroupId } from 'modules/groups/selectors';
import { getSelectedDealerId } from 'selectors/dealerSelectors';
import { getCurrentRoute } from 'services/RouterUtils';

import { Dropdown } from '../base';
import { overlayStyle } from './style';
import useReducedNavigation from './useReducedNavigation';

import * as stylesHeader from '../layout/header/Header.module.less';

const ConfigurationButton = () => {
  const location = useLocation();
  const groupId = useSelector(getSelectedGroupId);
  const dealerId = useSelector(getSelectedDealerId);

  const navigation = useReducedNavigation();
  const haveNavigation = navigation.length > 0;

  const items = React.useMemo(
    () =>
      navigation.map(group => ({
        key: group.name,
        type: 'group',
        children: group?.children?.map(child => ({
          key: getCurrentRoute(child.to.path),
          icon: <i className={`fb-icon--${child.icon}`} />,
          label: (
            <Link to={generatePath(child.to.path, { dealerId: dealerId || '', groupId: groupId || '', tabKey: 'general' })} data-cy={child['data-cy']}>
              <FormattedMessage id={child.name} defaultMessage={child.defaultMessage ?? child.name} />
            </Link>
          ),
        })),
      })),
    [navigation, groupId, dealerId]
  );

  return (
    haveNavigation && (
      <Dropdown
        menu={{
          items,
          className: overlayStyle,
          selectedKeys: [getCurrentRoute(location.pathname)],
        }}
      >
        <a
          className={classNames([stylesHeader['header-usernav__link'], stylesHeader['header-usernav__wrapper']])}
          data-cy="configuration_Navigation_Btn"
        >
          <i className={classNames([stylesHeader['header-usernav__icon'], 'fb-icon--settings'])} />
          <span className={stylesHeader['header-usernav__label']}>
            <FormattedMessage id="configuration" defaultMessage="Configuration" />
          </span>
          <i className={classNames([stylesHeader['header-usernav__caret-down'], 'fb-icon--arrow-down'])} />
        </a>
      </Dropdown>
    )
  );
};

export default ConfigurationButton;
